import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import LoadingTable from '../../components/LoadingTable';
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import getDecryptData from '../../../helpers/getDecryptData';

const MySwal = withReactContent(Swal);

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);

const monthOptions = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

function AllOrderInvoice() {

  const [AllDriver, setAllDriver] = useState([]);
  const [DriverId, setDriverId] = useState(null);
  const [OrderId, setOrderId] = useState(null);
  const [Dloading, setDLoading] = useState(true);

  const [dateFilterType, setDateFilterType] = useState('all');
  const [customStartDate, setCustomStartDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [selectedMonth, setSelectedMonth] = useState(String(new Date().getMonth() + 1).padStart(2, '0'));
  const [selectedMonthYear, setSelectedMonthYear] = useState(String(currentYear));
  const [selectedYear, setSelectedYear] = useState(String(currentYear));

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({ status: "" });

  const decryptdatajson = getDecryptData();

  // ─── All filter values passed as params — never reads from stale closure ─────
  const fetchData = async ({
    page = currentPage,
    filterType = dateFilterType,
    startDate = customStartDate,
    endDate = customEndDate,
    month = selectedMonth,
    monthYear = selectedMonthYear,
    year = selectedYear,
    search = searchTerm,
    status = formData.status,
    lim = limit,
  } = {}) => {

    let employeeId = null;
    const id = decryptdatajson?._id;
    if (decryptdatajson.type === 1 && decryptdatajson.empType === 2) {
      employeeId = id;
    }

    // Build date query string from explicitly passed values (not state)
    let dateParams = '';
    if (filterType === 'custom' && startDate && endDate) {
      dateParams = `&startDate=${startDate}&endDate=${endDate}`;
    } else if (filterType === 'monthly') {
      dateParams = `&month=${month}&year=${monthYear}`;
    } else if (filterType === 'yearly') {
      dateParams = `&year=${year}`;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/admin/all-order?page=${page}&limit=${lim}&search=${search}&status=${status}&employeeId=${employeeId}${dateParams}`
      );
      setData(response.data.Order || []);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching data:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    fetchData({ page: currentPage, lim: limit });
  }, [currentPage, limit]);

  const handleDriverChange = (OrderId) => async (event) => {
    const val = event.target.value;
    if (val !== undefined) setDriverId(val);
  };

  const selectDriver = async (OrderId, driver, cat, type, distance, empType) => {
    fetchemployeeData(cat, type, empType, distance);
    setOrderId(OrderId);
    setDriverId(driver);
  };

  const fetchemployeeData = async (cat, type, empType, distance) => {
    setAllDriver([]);
    try {
      const response = await axiosInstance.get(
        `/all-employee?type=${type}&longitude=${distance?.longitude || ''}&latitude=${distance?.latitude || ''}&empType=${empType}`
      );
      const { success, users } = response.data;
      if (success) setAllDriver(users);
    } catch (error) {
      console.error('Error fetching Driver:', error);
    }
  };

  const handleClickDriverChange = async () => {
    setDLoading(true);
    try {
      const res = await axiosInstance.put(`/admin/update-employee-order/${OrderId}`, { agentId: DriverId });
      if (res.data.success) {
        setDLoading(false);
        toast.success("Employee Updated success!");
      }
    } catch (error) {
      console.error('Error Updated Employee', error);
      setDLoading(false);
    } finally {
      fetchData({});
    }
  };

  const handleClickAsignChange = async () => {
    setDLoading(true);
    try {
      const res = await axiosInstance.put(`/admin/update-employee-order/${OrderId}`, { asignId: DriverId });
      if (res.data.success) {
        setDLoading(false);
        toast.success("Vendor Updated success!");
      }
    } catch (error) {
      console.error('Error Updated Vendor', error);
      setDLoading(false);
    } finally {
      fetchData({});
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const downloadInvoice = async (id) => {
    try {
      const response = await toast.promise(
        axiosInstance.post(`/download-invoice-order`, { invoiceId: id }, { responseType: 'blob' }),
        { loading: 'Invoice Downloading...', success: 'Invoice Downloaded!', error: 'Failed to Download Invoice.' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'invoice.pdf');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error('Error exporting data:', error);
      toast.error('Error exporting data');
    }
  };

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    fetchData({ page: 1, search: searchTerm });
  };

  // ─── Pass current UI values directly — bypasses stale state ─────────────────
  const handleApplyDateFilter = () => {
    setCurrentPage(1);
    fetchData({
      page: 1,
      filterType: dateFilterType,
      startDate: customStartDate,
      endDate: customEndDate,
      month: selectedMonth,
      monthYear: selectedMonthYear,
      year: selectedYear,
    });
  };

  const handleResetDateFilter = () => {
    const resetMonth = String(new Date().getMonth() + 1).padStart(2, '0');
    const resetYear = String(currentYear);

    setDateFilterType('all');
    setCustomStartDate('');
    setCustomEndDate('');
    setSelectedMonth(resetMonth);
    setSelectedMonthYear(resetYear);
    setSelectedYear(resetYear);
    setCurrentPage(1);

    // Pass reset values directly since setState is async
    fetchData({
      page: 1,
      filterType: 'all',
      startDate: '',
      endDate: '',
      month: resetMonth,
      monthYear: resetYear,
      year: resetYear,
    });
  };
  // ─────────────────────────────────────────────────────────────────────────────

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4">All Orders Invoice</h1>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="table-responsive py-4">
            {loading ? (
              <LoadingTable />
            ) : (
              <>
                {/* ── Row 1: Entries per page + Search ── */}
                <div className="datatable-top">
                  <div className="datatable-dropdown">
                    <label>
                      <select
                        className="datatable-selector"
                        value={limit}
                        onChange={(e) => {
                          setlimit(parseInt(e.target.value, 10));
                          setCurrentPage(1);
                        }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                      </select>{" "}entries per page
                    </label>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <div className="datatable-search">
                      <input
                        className="datatable-input"
                        type="text"
                        placeholder="Search...(By Order ID)"
                        value={searchTerm}
                        onChange={handleSearchInputChange}
                      />
                    </div>
                    <button className="btn btn-primary" onClick={handleSearch}>Search</button>
                  </div>
                </div>

                {/* ── Row 2: Date Filter (always fully visible) ── */}
                <div className="d-flex align-items-center flex-wrap gap-2 px-3 pb-3">
                  <label className="mb-0 fw-semibold me-1">Filter by Date:</label>

                  <select
                    className="form-control"
                    style={{ width: 'auto' }}
                    value={dateFilterType}
                    onChange={(e) => {
                      const val = e.target.value;
                      setDateFilterType(val);
                      if (val === 'all') {
                        setCurrentPage(1);
                        fetchData({ page: 1, filterType: 'all' });
                      }
                    }}
                  >
                    <option value="all">All Dates</option>
                    <option value="custom">Custom Date</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </select>

                  {dateFilterType === 'custom' && (
                    <>
                      <input
                        type="date"
                        className="form-control"
                        style={{ width: 'auto' }}
                        value={customStartDate}
                        onChange={(e) => setCustomStartDate(e.target.value)}
                      />
                      <span className="fw-bold">to</span>
                      <input
                        type="date"
                        className="form-control"
                        style={{ width: 'auto' }}
                        value={customEndDate}
                        min={customStartDate}
                        onChange={(e) => setCustomEndDate(e.target.value)}
                      />
                    </>
                  )}

                  {dateFilterType === 'monthly' && (
                    <>
                      <select
                        className="form-control"
                        style={{ width: 'auto' }}
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                      >
                        {monthOptions.map((m) => (
                          <option key={m.value} value={m.value}>{m.label}</option>
                        ))}
                      </select>
                      <select
                        className="form-control"
                        style={{ width: 'auto' }}
                        value={selectedMonthYear}
                        onChange={(e) => setSelectedMonthYear(e.target.value)}
                      >
                        {yearOptions.map((y) => (
                          <option key={y} value={y}>{y}</option>
                        ))}
                      </select>
                    </>
                  )}

                  {dateFilterType === 'yearly' && (
                    <select
                      className="form-control"
                      style={{ width: 'auto' }}
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(e.target.value)}
                    >
                      {yearOptions.map((y) => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  )}

                  <button
                    className="btn btn-success"
                    onClick={handleApplyDateFilter}
                    disabled={dateFilterType === 'custom' && (!customStartDate || !customEndDate)}
                  >
                    Apply
                  </button>

                  {dateFilterType !== 'all' && (
                    <button className="btn btn-outline-secondary" onClick={handleResetDateFilter}>
                      Reset
                    </button>
                  )}
                </div>

                <table className="table table-flush hidden-table">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      {(decryptdatajson.type === 0 || (decryptdatajson.type === 1 && decryptdatajson.empType === 1)) &&
                        <th>User Detail</th>
                      }
                      <th>Order Detail</th>
                      <th>Order Status</th>
                      {(decryptdatajson.type === 0 || (decryptdatajson.type === 1 && decryptdatajson.empType === 1)) &&
                        <th>Action</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {data.length !== 0 && data.map((row) => (
                      <tr key={row._id}>
                        <td>{row.orderId}</td>

                        {(decryptdatajson.type === 0 || (decryptdatajson.type === 1 && decryptdatajson.empType === 1)) &&
                          <td className='overflow-visible'>
                            <div style={{ whiteSpace: "break-spaces", maxWidth: 200 }}>
                              <b>Name: </b>{row?.details[0]?.username || "NA"}<br />
                              <b>Phone: </b>{row?.details[0]?.phone || "NA"}
                            </div>
                          </td>
                        }

                        <td>
                          {row?.order === 2 &&
                            <b className="badge rounded-pill bg-success p-2 me-2 mt-2">Store Order</b>
                          }
                          {row.items[0]?.id === '1' ?
                            <b className="badge rounded-pill bg-success p-2 me-2 mt-2">Custom Order</b>
                            :
                            <b className="badge rounded-pill bg-dark p-2 me-2 mt-2">Normal Order</b>
                          }
                        </td>

                        {(decryptdatajson.type === 0 || (decryptdatajson.type === 1 && decryptdatajson.empType === 1)) &&
                          row.items[0]?.id === '1' &&
                          <td>
                            {row.agentId ? (
                              <button
                                className="btn mb-2 btn-sm btn-primary p-2 d-inline text-start me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#modal-driver"
                                onClick={() => selectDriver(row._id, row.driverId?._id, row?.category, 1, { longitude: row.longitude, latitude: row.latitude }, 2)}
                              >
                                {row.agentId?.username}
                              </button>
                            ) : (
                              <button
                                className="btn mb-2 btn-sm btn-danger p-2 d-inline text-start me-2"
                                onClick={() => selectDriver(row._id, row.driverId?._id, row?.category, 1, { longitude: row.longitude, latitude: row.latitude }, 2)}
                                data-bs-toggle="modal"
                                data-bs-target="#modal-driver"
                              >
                                Not Assign
                              </button>
                            )}
                          </td>
                        }

                        <td>
                          <div style={{ whiteSpace: "break-spaces", maxWidth: 200 }}>
                            {row.status !== 0 && row.status !== 8 ? (
                              <span className={`text-white px-2 rounded mt-2 d-inline-block ${row.payment === 0 ? 'bg-danger' : row.payment === 1 ? 'bg-success' : 'bg-warning'}`}>
                                {row.payment === 0 ? 'unpaid' : row.payment === 1 ? 'Full Paid' : row.payment === 3 ? 'Partially Paid' : 'failed'}
                                {' '} - ₹{row.paid}
                              </span>
                            ) : row.status === 8 ? (
                              <>
                                <span className="bg-success text-white px-2 py-1 rounded-pill">Completed</span>
                                <p className="small pt-2 border-top mt-3">
                                  <span className={`text-white px-2 py-1 rounded ${row.payment === 1 ? 'bg-success' : 'bg-danger'}`}>
                                    Payment: {row.payment === 1 ? 'Paid' : 'Unpaid'}
                                  </span>
                                </p>
                              </>
                            ) : (
                              <>
                                <span className="bg-danger text-white px-2 py-1 rounded-pill">Cancelled</span>
                                <p className="small pt-2 border-top mt-3">
                                  <b className="badge rounded-pill bg-dark me-2">Comment</b>{row.comment}
                                </p>
                              </>
                            )}
                          </div>
                        </td>

                        {(decryptdatajson.type === 0 || (decryptdatajson.type === 1 && decryptdatajson.empType === 1)) &&
                          <td>
                            <button className="btn btn-primary" onClick={() => downloadInvoice(row._id)}>
                              Invoice
                            </button>
                          </td>
                        }
                      </tr>
                    ))}

                    {data.length === 0 && (
                      <tr>
                        <td colSpan="6" className="text-center py-4 text-muted">No orders found for the selected filter.</td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <div className="datatable-bottom">
                  <div className="datatable-info"></div>
                  <nav className="datatable-pagination">
                    <ul className="datatable-pagination-list">
                      <li className={`datatable-pagination-list-item ${currentPage === 1 ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button
                          className="datatable-pagination-list-item-link"
                          onClick={handlePreviousPage}
                          disabled={loading || currentPage === 1}
                          aria-label="Previous page"
                        >‹</button>
                      </li>
                      <li>
                        <div className="datatable-info py-1 px-3">
                          <strong>Page {currentPage} of {totalPages}</strong>
                        </div>
                      </li>
                      <li className={`datatable-pagination-list-item ${currentPage === totalPages ? 'datatable-hidden' : 'datatable-active'}`}>
                        <button
                          className="datatable-pagination-list-item-link"
                          aria-label="Next page"
                          onClick={handleNextPage}
                          disabled={loading || currentPage === totalPages}
                        >{loading ? 'Loading...' : '›'}</button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Modal - Driver */}
        <div className="modal fade" id="modal-driver" tabIndex={-1} style={{ display: "none" }} aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <label>Choose Employee</label>
                <select className="form-control select" style={{ width: "100%" }} onChange={handleDriverChange(OrderId)}>
                  <option>Select Employee</option>
                  {AllDriver.length > 0 ? (
                    AllDriver.map(driver => (
                      <option
                        value={driver._id}
                        key={driver._id}
                        selected={driver._id === DriverId}
                        style={{ color: driver.online === 1 ? 'green' : 'red' }}
                      >
                        {driver?.distance?.kilometers !== 0 && driver?.distance?.kilometers && <>({driver?.distance?.kilometers} Km) </>}
                        {driver.username} - {driver.online === 1 ? '(Online)' : '(Offline)'}
                      </option>
                    ))
                  ) : (
                    <option disabled>No Employee found.</option>
                  )}
                </select>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" type="button" data-bs-dismiss="modal" onClick={handleClickDriverChange}>Update Employee</button>
                <button type="button" className="btn btn-gray-300 ms-auto" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

        {/* Modal - Vendor */}
        <div className="modal fade" id="modal-vendor" tabIndex={-1} style={{ display: "none" }} aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <label>Choose Vendor</label>
                <select className="form-control select" style={{ width: "100%" }} onChange={handleDriverChange(OrderId)}>
                  <option>Select Vendor</option>
                  {AllDriver.length > 0 ? (
                    AllDriver.map(driver => (
                      <option value={driver._id} key={driver._id} selected={driver._id === DriverId}>
                        {driver.username}
                      </option>
                    ))
                  ) : (
                    <option disabled>No Vendor found.</option>
                  )}
                </select>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" type="button" data-bs-dismiss="modal" onClick={handleClickAsignChange}>Update vendor</button>
                <button type="button" className="btn btn-gray-300 ms-auto" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>

      </main>
    </>
  );
}

export default AllOrderInvoice;